module.exports = __webpack_public_path__ + "img/gartentor_1.28c708f9.jpg";